// Recovered compiled webpack factory 76196. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  function r(e) {
    return e.startsWith("/") ? e : "/" + e;
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "ensureLeadingSlash", {
      enumerable: !0,
      get: function () {
        return r;
      },
    }));
}
